import { Box, StyleProps } from '@chakra-ui/react'

export interface SeparatorProps extends StyleProps {}

export const Separator = ({ ml, mr }: SeparatorProps) => (
  <Box
    height="59px"
    marginLeft={ml ? ml : '25px'}
    marginRight={mr ? mr : '25px'}
    borderLeft="1px solid"
    borderColor="presets.neutral.20"
  ></Box>
)
